export let CanBePlayedCard;
CanBePlayedCard = function (card, playerFire, playerPow, playerDiamond, playerTable, cpuTable, tutorial, handKey) {
    let canBePlayed = true;

    // check mana cost
    for (const [type, value] of Object.entries(JSON.parse(card.cost))) {

        // @ts-ignore
        if (type === 'pow' && playerPow.amount < value) {
            canBePlayed = false;
        }
        // @ts-ignore
        if (type === 'diamond' && playerDiamond.amount < value) {
            canBePlayed = false;
        }
        // @ts-ignore
        if (type === 'fire' && playerFire.amount < value) {
            canBePlayed = false;
        }
    }

    // check free place for unit
    if (card.type_card === 'unit' && canBePlayed) {
        canBePlayed = false;
        for (let i = 0; i < 5; i++) {

            if (playerTable[i] === null || playerTable[i] === 0) {
                canBePlayed = true;
            }
        }
    }

    // it has target
    if (
        card.type_card === 'spell' &&
        canBePlayed &&
        card.ability.aim_target === 'unit'
    ) {
        const hasUnit = (t: any) =>
            [0, 1, 2, 3, 4].some((i) => {
                const cell = t?.[i];
                return cell !== null && cell !== 0 && typeof cell !== 'undefined';
            });

        const side = card.ability.side_target;

        if (side === 'both') {
            canBePlayed = hasUnit(cpuTable) || hasUnit(playerTable);
        } else if (side === 'player') {
            canBePlayed = hasUnit(playerTable);
        } else {
            // default: opponent/cpu side
            canBePlayed = hasUnit(cpuTable);
        }
    }

    // tutorial
    if(tutorial.step === "PlayFirstCard40" && handKey != 0){ // Fire
        canBePlayed = false;
    }

    if(tutorial.step === "PlaySecondCard50" && handKey != 0){ // Minion
        canBePlayed = false;
    }

    if(tutorial.step === "PlaySpellCard70" && handKey != 0){ // FireBolt
        canBePlayed = false;
    }


    return canBePlayed;
}